module.exports = __webpack_public_path__ + "static/media/downloadGreen.451c1797.svg";